<template>
    <div class="select-wrapper">
<!--        <div class="select&#45;&#45;title pb-1 pr-1">{{ $t('base.color') }}</div>-->
        <div class="select-field">
            <select
                class="product--base-info"
                v-model="value"
                @change="change"
            >
                <option
                    v-for="item in collection"
                    :class="{ selected: value === item }"
                    :selected="value === item"
                    :value="item"
                >
                    {{ item.label }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    import EventBus from "../../event-bus";
    import { gtag_event } from "../../gtag";

    export default {
        data() {
            return {
                label: App.configuration.variants.colors.label,
                collection: App.configuration.variants.colors.elements,
            };
        },

        props: [ "value" ],

        methods: {
            change() {
                let vm = this;

                switch (this.value.class) {
                    case 'nut-tree':
                        gtag_event('Button Motivsockel Nussbaum', 1);
                        break;

                    case 'white':
                        gtag_event('Button Motivsockel Weiß', 2);
                        break;

                    case 'cake-topper':
                        gtag_event('Button CakeTopper', 4);
                        break;

                    case 'none':
                        gtag_event('Button Motivsockel Ohne', 3);
                        break;
                }

                if (this.value.class && "none" === this.value.class) {
                    this.$modal.show("dialog", {
                        title: vm._i18n.t("hint.color.none.title"),
                        text: vm._i18n.t("hint.color.none.text"),
                        buttons: [
                            {
                                title: vm._i18n.t("hint.color.none.button"),
                            },
                        ]
                    });
                }

                this.$emit("input", this.value);
                this.$nextTick(() => {
                    EventBus.$emit("colorChanged", this.value);
                });
            }
        }
    };
</script>

<style scoped lang="scss">
    @import "../../assets/scss/components/base";
</style>



// WEBPACK FOOTER //
// src/components/Base/Color.vue